import { Alert, Button, Col, Form, Image, Input, notification, Row, Select, Tooltip } from "antd";
import { useEffect, useState } from "react";
import InputForm from "../../../utils/InputForm";
import { ModalSelectEdivence } from "../ModalSelectEvidenceImage";
import usePost from "../../../../hooks/usePost";
import { FilePdfOutlined } from "@ant-design/icons";
import downloadPdf from "../../../../utils/DownloadPDF";

export default function UploatEvidences(props) {
  const {
    faltante,
    values,
    handleChange,
    resetForm,
    setFaltante,
    onRefetch,
    isEdit,
    setIsEdit,
    setViewEvidences,
    fileSelected,
    setFileSelected,
    setOpenUpload,
  } = props;

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { post, success, error, loading } = usePost();

  useEffect(() => {
    setFileSelected({
      base64Data: null,
      previewUrl: null,
      name: "",
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.type]);

  useEffect(() => {
    if (values.evidenceUrl !== "") {
      const name = values.evidenceUrl.split("/").pop();

      setFileSelected({
        base64Data: null,
        previewUrl: values.evidenceUrl,
        name: name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.evidenceUrl]);

  const handleSubmitEvidence = async () => {
    const data = {
      FCCODIGOFALTANTE: faltante.faltanteCode,
      FIEVIDENCIAID: values.evidenciaId || 0,
      FIESTATUSID: 1,
      FITIPOEVIDENCIA: parseInt(values.type),
      FCDESCRIPCION: values.description,
      FCEVIDENCIA: fileSelected.base64Data,
      FCNOMBRE: fileSelected.name,
    };

    await post("faltante/uploadFile", data);
  };

  useEffect(() => {
    if (success) {
      openNotificationWithIcon("success", isEdit ? "Evidencia editada" : "Evidencia agregada");

      onRefetch();

      handleCloseUploat();
    } else if (success === false) {
      openNotificationWithIcon("error", error);

      resetForm();
      setFileSelected({
        base64Data: null,
        previewUrl: null,
        name: "",
      });
      setViewEvidences(true);
      setOpenUpload(false);

      setFaltante({
        ...faltante,
        open: true,
      });

      onRefetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const isSubmitDisabled = () => {
    return values.type === 0 || fileSelected.base64Data === null || loading;
  };

  const handleCloseUploat = () => {
    resetForm();
    setFileSelected({
      base64Data: null,
      previewUrl: null,
    });
    setIsEdit(false);
    setViewEvidences(true);
    setOpenUpload(false);
  };

  function shortenName(name) {
    const maxLength = 10;
    return name?.length > maxLength ? name.substring(0, maxLength) + "..." : name;
  }

  return (
    <>
      {contextHolder}
      <Row justify="center">
        <Col span={24}>
          <div className="input-content-titulo">{isEdit ? "Editar" : "Agregar"} evidencia</div>
        </Col>
      </Row>
      {isEdit && fileSelected.base64Data === null ? (
        <Row justify="center">
          <Alert message="Seleccionar evidencia para poder editar." type="warning" showIcon />
        </Row>
      ) : null}

      <Row justify="space-around" align="top">
        <Col xs={20} md={10} className="mt-3" al>
          <InputForm
            handleChange={null}
            value={faltante.faltanteCode}
            name={"FCNOSERIE"}
            type={"text"}
            label={"Código faltante"}
            disabled={true}
          />
          {/* {errors && <div className="error-input-data">{errors.FCNOSERIE}</div>} */}
        </Col>
        <Col xs={20} md={10} className="mt-3" al>
          <label className="text-context-inputs">Tipo:</label>

          <Form.Item>
            <Select onChange={(value) => handleChange("type", value)} value={values.type}>
              <Select.Option value={0} disabled>
                Seleccionar
              </Select.Option>
              <Select.Option value={1}>Imagen JPG</Select.Option>
              <Select.Option value={2}>PDF</Select.Option>
            </Select>
          </Form.Item>
          {/* <InputSelect
            value={null}
            handleChange={null}
            options={EvidenceType}
            label="Tipo"
            // optionsKey={"FITIPOATBID"}
            // optionsName={"FCNOMBRETIPO"}
            //disabled={selectedItem ? true : false} //deshabilita en caso de que sea edit
            // name={"FITIPOATBID"}
          /> */}
          {/* {errors && (
            <div className="error-input-data">{errors.FITIPOATBID}</div>
          )} */}
        </Col>

        <Col xs={20} md={22} al>
          <label className="text-context-inputs">Descripción:</label>
          <Form.Item>
            <Input
              value={values.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </Form.Item>
          {/* <InputForm
            handleChange={null}
            value={null}
            name={"FCAFILIACION"}
            type={"text"}
            label={"Descripción"}
          /> */}
          {/* {errors && (
            <div className="error-input-data">{errors.FCAFILIACION}</div>
          )} */}
        </Col>
        <Col xs={20} md={10} al>
          <label className="text-context-inputs">Evidencia:</label>
          <div className="row-image-banner">
            <div className="image-content">
              {fileSelected.previewUrl !== null && values.type === 1 ? (
                <div>
                  <Image
                    src={fileSelected.previewUrl}
                    alt="Evidencia"
                    style={{
                      maxWidth: "100px",
                      height: "50px",
                    }}
                  />
                </div>
              ) : fileSelected.previewUrl !== null && values.type === 2 ? (
                <>
                  <FilePdfOutlined
                    style={{
                      fontSize: "20px",
                      color: "#1890ff",
                      cursor: "pointer",
                      paddingRight: "10px",
                    }}
                    onClick={() => downloadPdf(fileSelected.name, fileSelected.previewUrl)}
                  />
                  <Tooltip title={fileSelected.name}>
                    <span>{shortenName(fileSelected.name)}</span>
                  </Tooltip>
                </>
              ) : null}
            </div>
            <div>
              <Button
                className={"button-styles-add-element"}
                onClick={() => setModalIsOpen(true)}
                disabled={values.type === 0}
                type="primary"
                size="small"
              >
                Seleccionar evidencia
              </Button>
            </div>
          </div>
          {/* {errors && (
            <div className="error-input-data">
              {errors.FCURLFOTOGRAFICAFRONTAL}
            </div>
          )} */}
        </Col>
      </Row>
      <Row justify="space-evenly" align="bottom">
        <Col xs={20} md={8} className="mt-3" al>
          <Button
            onClick={handleCloseUploat}
            variant="primary"
            danger
            className="button-styles-cancel"
          >
            Volver
          </Button>
        </Col>
        <Col xs={20} md={8} className="mt-3" al>
          <Button
            onClick={handleSubmitEvidence}
            className="button-modal button-styles-add-element"
            disabled={isSubmitDisabled()}
            type="primary"
            loading={loading}
          >
            {loading ? "Cargando..." : isEdit ? "Editar" : "Agregar"}
          </Button>
        </Col>
      </Row>
      <>
        <ModalSelectEdivence
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          fileSelected={fileSelected}
          setFileSelected={setFileSelected}
          values={values}
          isEdit={isEdit}
        />
      </>
    </>
  );
}
